import React from 'react';
import { toast } from 'react-toastify';
import IntlMessages from 'util/IntlMessages';
import isDirectionRTL from 'util/isDirectionRTL';

const isRTL = isDirectionRTL();

const shownMessages = new Set();
// Function displays message passed to function or a default message otherwise based on message type
export const showNotificationMessage = (
    type,
    message,
    delay,
    onClick = undefined,
) => {
    const defaultKeys = {
        success: 'notification.success.unknown',
        error: 'notification.error.unknown',
    };

    const titleKeys = {
        success: 'notification.success',
        error: 'notification.error',
    };

    const isSuccess = type === 'success';
    const isError = type === 'error';

    const key = message || defaultKeys[type];
    const keyId =
        typeof key === 'object' && key?.props?.id
            ? key.props.id
            : typeof key === 'string'
              ? key
              : JSON.stringify(key);

    if (shownMessages.has(keyId)) return;

    shownMessages.add(keyId);

    const title = (
        <div className='text-white'>
            <IntlMessages id={titleKeys[type]} />
        </div>
    );

    const description = (
        <div>{message || <IntlMessages id={defaultKeys[type]} />}</div>
    );

    const toastOptions = {
        theme: 'colored',
        autoClose: delay || (isSuccess ? 2000 : 15000),
        onClose: () => shownMessages.delete(keyId), // Delay to ensure the message is removed after the toast closes
    };

    const content = (
        <div className={isRTL ? 'arabicFont' : 'englishFont'} onClick={onClick}>
            {title}
            {description}
        </div>
    );

    return isSuccess
        ? toast.success(content, toastOptions)
        : isError
          ? toast.error(content, toastOptions)
          : toast(content, toastOptions); // fallback/default
};

export default showNotificationMessage;

export const getErrorMessageByStatus = (status) => {
    switch (status) {
        case 400:
            return 'shared.error.400';
        case 404:
            return 'shared.error.404';
        case 500:
        case 502:
            return 'shared.error.500';
        default:
            return status;
    }
};

export const getErrorMessage = (message) => {
    switch (message) {
        case 'no company found':
            return 'shared.error.r01';
        case 'Authentication failed. User not found':
            return 'shared.error.r03';
        case 'Authentication failed. Wrong password':
        case 'Authenticating failed':
            return 'shared.error.r05';
        case "You don't have any permissions":
            return 'shared.error.r06';
        case 'No token provided.':
            return 'shared.error.unknown';
        case 'Display not found':
            return 'shared.error.400';
        default:
            return 'shared.error.unknown';
    }
};

export const displayErrorMessage = (error, showNotification = true) => {
    let errorMessageKey;

    if (error.response && (error.response.data || error.response.status)) {
        if (error.response.data && error.response.data.error) {
            errorMessageKey = getErrorMessage(error.response.data.error);
        } else {
            errorMessageKey = getErrorMessageByStatus(error.response.status);
        }
    }

    let errorMessage;

    if (errorMessageKey) {
        errorMessage = <IntlMessages id={errorMessageKey} />;
    } else {
        errorMessage = error.message ? error.message : '';
    }

    if (showNotification) {
        showNotificationMessage('error', errorMessage);
    }

    return errorMessage;
};
